export type ThemeVariant = 'light' | 'dark' | 'auto';
export type NavPositionVariant = 'horizontal' | 'vertical' | 'combo' | 'dual';
export type NavTopShapeVariant = 'default' | 'slim';
export type NavbarAppearanceVariant = 'default' | 'darker';

// Add company interface
export interface Company {
  id_entidade: number;
  name: string;
  logo: string;
  modulo1: string;
  modulo2: string;
  modulo3: string;
  modulo4: string;
  modulo5: string;
  modulo6: string;
}

export interface CompanyState {
  company: Company | null;
  isLoading: boolean;
  error: string | null;
}

// Add company interface
export interface UserModule {
  id_modulo: number;
  id_permissao: number;
}

// add car interface
export interface car {
  idcarro: number;
  carPlate: string;
  capacity: number;
  available: boolean;
}

export interface User {
  id_user: number;
  name: string;
}

export interface AuthData {
  user: User | null;
  modules: UserModule[];
  isAuthenticated: boolean;
}

export interface AuthState {
  authData: AuthData;
  isLoading: boolean;
  error: string | null;
}

export interface Config {
  isNavbarVerticalCollapsed: boolean;
  openNavbarVertical: boolean;
  theme: ThemeVariant;
  navbarVerticalAppearance: NavbarAppearanceVariant;
  navbarTopAppearance: NavbarAppearanceVariant;
  navbarPosition: NavPositionVariant;
  navbarTopShape: NavTopShapeVariant;
  isRTL: boolean;
  isDark: boolean;
  bodyClass?: string;
  isChatWidgetVisible: boolean;
  // Add company state
  companyState: CompanyState;
  // Add auth state
  authState: AuthState;
}

export const initialConfig: Config = {
  isNavbarVerticalCollapsed: true,
  openNavbarVertical: false, // for responsive
  theme: 'light',
  navbarTopAppearance: 'default',
  navbarVerticalAppearance: 'default',
  navbarPosition: 'vertical',
  navbarTopShape: 'default',
  isRTL: false,
  isDark: false,
  isChatWidgetVisible: true,
  companyState: {
    company: null,
    isLoading: false,
    error: null
  },
  authState: {
    authData: {
      user: null,
      modules: [],
      isAuthenticated: false
    },
    isLoading: false,
    error: null
  }
};
